import { createSlice, Draft, PayloadAction } from '@reduxjs/toolkit';

export type AppState = {
	loading: boolean;
	isValidUser: boolean;
};

const initialState: AppState = {
	loading: false,
	isValidUser: false,
};

export const userSlice = createSlice({
	name: 'user',
	initialState,
	reducers: {
		setLoading: (
			state: Draft<AppState>,
			action: PayloadAction<boolean>,
		) => {
			state.loading = action.payload;
		},
		setValidUser: (
			state: Draft<AppState>,
			action: PayloadAction<boolean>,
		) => {
			state.isValidUser = action.payload;
		},
	},
});

export const userActions = userSlice.actions;
const userReducer = userSlice.reducer;

export default userReducer;
